import { RootState } from "../index";
import { createDraftSafeSelector } from "@reduxjs/toolkit";

const selectAppReducer = (state: RootState) => state;

export const selectSystem = createDraftSafeSelector(
  selectAppReducer,
  (state) => state.system,
);

export const selectUserInfo = createDraftSafeSelector(
  selectSystem,
  (state) => state?.userInfo,
);

export const selectSystemLanguage = createDraftSafeSelector(
  selectSystem,
  (state) => state?.language,
);

export const selectSystemLogin = createDraftSafeSelector(
  selectSystem,
  (state) => state?.login,
);

export const selectAuth = createDraftSafeSelector(
  selectSystem,
  (state) => state?.auth,
);

export const selectNotificationList = createDraftSafeSelector(
  selectSystem,
  (state) => state?.notificationList,
);

export const selectAuthLoader = createDraftSafeSelector(
  selectSystem,
  (state) => state?.authLoader,
);

export const selectAuthError = createDraftSafeSelector(
  selectSystem,
  (state) => state?.authError,
);

export const selectDashboardLoader = createDraftSafeSelector(
  selectSystem,
  (state) => state?.dashboardLoader,
);

export const selectAuthorizedUser = createDraftSafeSelector(
  selectUserInfo,
  (state) => state?.authorizedUser,
);

export const selectUserPosition = createDraftSafeSelector(
  selectUserInfo,
  (state) => state?.position,
);

export const selectPrimaryTenant = createDraftSafeSelector(
  selectAuthorizedUser,
  (state) => state?.primaryTenant,
);
